import React from 'react';
import { Helmet } from 'react-helmet-async';

const PerformanceOptimizations = ({ criticalCSS, preloadFonts = [], preloadImages = [] }) => {
  return (
    <Helmet>
      {/* Critical CSS inlined */}
      {criticalCSS && (
        <style type="text/css">
          {criticalCSS}
        </style>
      )}
      
      {/* Preload critical fonts */}
      {preloadFonts.map((font, index) => (
        <link
          key={index}
          rel="preload"
          href={font.href}
          as="font"
          type={font.type || "font/woff2"}
          crossOrigin="anonymous"
        />
      ))}
      
      {/* Preload critical images */}
      {preloadImages.map((image, index) => (
        <link
          key={index}
          rel="preload"
          href={image}
          as="image"
        />
      ))}
      
      {/* Resource hints for better performance */}
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//images.unsplash.com" />
      <link rel="dns-prefetch" href="//www.google-analytics.com" />
      <link rel="dns-prefetch" href="//www.googletagmanager.com" />
      
      {/* Prefetch common navigation targets */}
      <link rel="prefetch" href="/about" />
      <link rel="prefetch" href="/places" />
      <link rel="prefetch" href="/hotels" />
      
      {/* Service Worker registration hint */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="application-name" content="Safarnamah" />
      <meta name="apple-mobile-web-app-title" content="Safarnamah" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="msapplication-TileColor" content="#D4C4B0" />
      <meta name="theme-color" content="#D4C4B0" />
    </Helmet>
  );
};

export default PerformanceOptimizations;